import { jsx } from 'react/jsx-runtime';
import { useCallback } from 'react';
import { Toaster as Toaster$1 } from 'react-hot-toast';
import { Icon } from '../Icon/Icon.es.js';
import { Toast } from './Toast/Toast.es.js';
import { useToast } from './useToast/useToast.es.js';

const Toaster = ({ toastOptions, position = 'bottom-center', containerStyle = {
    inset: '2rem'
}, ...rest })=>{
    const { dismiss } = useToast();
    const handleDismiss = useCallback((id)=>()=>{
            dismiss(id);
        }, [
        dismiss
    ]);
    return jsx(Toaster$1, {
        containerStyle: containerStyle,
        position: position,
        toastOptions: {
            duration: 5000,
            success: {
                icon: jsx(Icon, {
                    name: "CheckCircleSolid",
                    size: 20
                }),
                className: 'success'
            },
            ...toastOptions
        },
        ...rest,
        children: (t)=>jsx(Toast, {
                onDismiss: handleDismiss(t.id),
                position: t.position ?? position,
                toast: t
            })
    });
};
Toaster.displayName = 'Toaster';

export { Toaster, Toaster as default };
//# sourceMappingURL=Toaster.es.js.map
